export const TOP_BAR_HEIGHT = 64;
export const BOTTOM_BAR_HEIGHT = 64;

export const appFlavors = [
  {
    value: "base",
    label: "Resinglass",
  },
  {
    value: "fhenus",
    label: "Fhenus",
  },
  {
    value: "diamante",
    label: "Diamante",
  },
  {
    value: "lamole",
    label: "Lamole",
  },
  {
    value: "mm",
    label: "M&M",
  },
  {
    value: "starposa",
    label: "Starposa",
  },
  {
    value: "tendasi",
    label: "TENDASI",
  },
  {
    value: "tmg",
    label: "TMG",
  },
  {
    value: "vetrocover",
    label: "VetroCover",
  },
] as const;
